declare namespace $ {

	type $shm_hitalama_map_widget_float_table_follower__offset_shm_hitalama_map_widget_float_table_pick_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_pick['bubble_offset'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_follower['offset'] >
	>
	type $shm_hitalama_map_widget_float_table_follower__align_shm_hitalama_map_widget_float_table_pick_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_pick['bubble_align'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_follower['align'] >
	>
	type $shm_hitalama_map_widget_float_table_follower__Anchor_shm_hitalama_map_widget_float_table_pick_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_pick['Anchor'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_follower['Anchor'] >
	>
	type $shm_hitalama_map_widget_float_table_follower__Sub_shm_hitalama_map_widget_float_table_pick_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_widget_float_table_pick['Bubble'] >
		,
		ReturnType< $shm_hitalama_map_widget_float_table_follower['Sub'] >
	>
	export class $shm_hitalama_map_widget_float_table_pick extends $mol_pick {
		Follower( ): $shm_hitalama_map_widget_float_table_follower
	}
	
}

//# sourceMappingURL=pick.view.tree.d.ts.map